export const hasSentryAuthToken = !!process.env.SENTRY_AUTH_TOKEN
